import Decimal from 'decimal.js';

import { Liability } from '@/types/schema';

export enum LiabilitiesTableColumns {
  NAME = 'name',
  LENDER = 'issuerName',
  DEBTOR = 'recipientName',
  PAYMENT_DETAILS = 'recurringPaymentAmount',
  PAYMENT_KIND = 'paymentKind',
  OUTSTANDING_BALANCE = 'currentValue',
  ACTIONS = 'actions',
}

export interface LiabilitiesTableRowData {
  id: string;
  name: string;
  notes: string;
  issuerName: string;
  recipientName: string;
  currentValue: Decimal;
  householdId: string;
  isIntegrationLinked: boolean;
  actions?: never;

  // payment details
  recurringPaymentAmount?: Liability['recurringPaymentAmount'];
  interestRate?: Liability['interestRate'];
  paymentFrequency?: Liability['paymentFrequency'];
  paymentKind?: Liability['paymentKind'];
  termStart?: Liability['termStart'];
  termEnd?: Liability['termEnd'];
  finalPaymentAmount?: Liability['finalPaymentAmount'];

  currentValueDisplay: string | undefined;
  lenderDisplay: string | undefined;
  issuerNameDisplay: string | undefined;
  recurringPaymentAmountDisplay: string;
  paymentFrequencyDisplay: string | undefined;
  paymentKindDisplay: string;
  finalPaymentAmountDisplay: string | undefined;
}
